// test312
(312 && 0);
